module.exports = __webpack_public_path__ + "static/top-b74885076ed7ed9638cb9784a9794df3.png";